export default function handleForms() {
    const hasError = ( field ) => {
        let validity = field.validity;
        let fullName = field.classList.contains( 'full-name' );
        let rentalInquiry = field.classList.contains( 'rental-inquiry' );
        let firstName = field.classList.contains( 'first-name' );
        let typeOfEvent = field.classList.contains( 'type-of-event' );
        let eventLocation = field.classList.contains( 'event-location' );
        let description = field.classList.contains( 'description' );

        let startMonth = field.classList.contains( 'start-month' );
        let startDay = field.classList.contains( 'start-day' );
        let startYear = field.classList.contains( 'start-year' );
        let endMonth = field.classList.contains( 'end-month' );
        let endDay = field.classList.contains( 'end-day' );
        let endYear = field.classList.contains( 'end-year' );

        if ( field.disabled || 'file' === field.type || 'reset' === field.type || 'submit' ===  field.type || 'button' ===  field.type ) return;

        if ( validity.valid ) return;

        if ( validity.valueMissing ) {
            if ( 'email' === field.type ) return 'Please enter an email address.';

            if ( fullName || firstName ) return 'Please enter your name.';

            if ( rentalInquiry ) return 'Please tell us the type of equipment your are inquiring about.';

            if ( typeOfEvent ) return 'Please tell us the type of event your are booking.';

            if ( eventLocation ) return 'Please tell us the location of your event.';

            if ( description ) return 'Please provide a description of your event.';

            if ( startMonth || startDay || startYear || endMonth || endDay || endYear) {
                return 'Date format must be MM / DD / YYYY with a valid month, day, and year';
            }
        }

        if ( validity.typeMismatch || validity.patternMismatch ) {
            if ( 'email' === field.type ) return 'Please enter a valid email address.';

            if ( fullName || firstName ) return 'Please enter a valid name.';

            if ( rentalInquiry ) return 'Please enter a valid equiptment description.';

            if ( startMonth || startDay || startYear || endMonth || endDay || endYear) {
                return 'Date format must be MM / DD / YYYY';
            }
        }

        if ( validity.tooShort ) return 'Your entry is too short, please enter a valid length of atleast 2 characters. For DATES, please use the following format MM/DD/YYYY';

        if ( validity.tooLong ) return 'Your entry is too long, please shorten your description.';
    };

    const showError = ( field, error ) => {
        field.classList.add( 'error' );

        if ( !field.nextElementSibling ) {
            return;
        }

        if ( field.parentNode.classList.contains( 'start-date-field' ) || field.parentNode.classList.contains( 'end-date-field' ) ) {
            field.parentNode.parentNode.nextElementSibling.innerHTML = error;
        }

        field.nextElementSibling.innerHTML = error;
    };

    const removeError = ( field ) => {
        field.classList.remove( 'error' );

        if ( !field.nextElementSibling ) {
            return;
        }

        if ( field.parentNode.classList.contains( 'start-date-field' ) || field.parentNode.classList.contains( 'end-date-field' ) ) {
            field.parentNode.parentNode.nextElementSibling.innerHTML = '';
        }

        field.nextElementSibling.innerHTML = '';
    };

    let forms = document.querySelectorAll( 'form' );
    [ ...forms ].forEach( form => {
        form.setAttribute( 'novalidate', true );

        form.addEventListener( 'blur', ( e ) => {
            let target = e.target;
            let targetForm = target.form;
            let error = hasError( target );

            if ( !targetForm.classList.contains( 'validate' ) ) return;

            // if ( target.parentNode.classList.contains( 'start-date-field' ) || target.parentNode.classList.contains( 'end-date-field' ) ) return;

            if ( error ) {
                showError( target, error );
                return;
            }

            removeError( target );

        }, true )

        form.addEventListener( 'submit', ( e ) => {
            let target = e.target;
            let fields = target.elements;
            let error, hasErrors;

            if ( !target.classList.contains( 'validate' ) ) return;

            [ ...fields ].forEach( ( field, i ) => {
                error = hasError( fields[ i ] );

                if ( error ) {
                    showError( fields[ i ], error );
                    if ( !hasErrors ) {
                        hasErrors = fields[ i ];
                    }
                }

                if ( hasErrors ) {
                    e.preventDefault();
                    hasErrors.focus();
                }
            } );
        } )
    } );
}

setTimeout( ( ) => { handleForms(); }, 500 );
